import React from 'react';
import PropTypes from 'prop-types';

import CountrySelector from '../CountrySelector';
import CustomIcon from '../CustomIcon';
import Label from '../Label';
import Markdown from '../Markdown';
import Span from '../Span';

const SPAN_DEFAULT = '';
const MARGIN_TOP_CLASS = 'mt-5';

const CountrySelectRenderer = ({ item, errors, fieldsValidated }) => (
  <div className={`col-lg-6 ${MARGIN_TOP_CLASS}`}>
    <div className="form-group">
      <Label
        label={item.label}
        name={item.name}
        errors={errors}
        required={item.required}
      />

      <CustomIcon
        fieldsValidated={fieldsValidated}
        fieldError={errors[item.name]}
        required={item.required}
      />

      <CountrySelector name={item.name} />

      <Span
        text={errors[item.name] ? errors[item.name].message : SPAN_DEFAULT}
      />

      <Markdown
        className="col-xl-12 col-lg-12 mt-3"
        text={item.description}
      />
    </div>
  </div>
);

CountrySelectRenderer.propTypes = {
  item: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  fieldsValidated: PropTypes.bool,
};

export default CountrySelectRenderer;
